require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-6-reasons-why-you-need-an-hsa-asap.json") })
        }
      }, "path---es-articles-6-reasons-why-you-need-an-hsa-asap");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-6-reasons-why-you-need-an-hsa-asap!./.cache/json/es-articles-6-reasons-why-you-need-an-hsa-asap.json
// module id = 2028
// module chunks = 231608221292675